import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import type {
  GetCareerRolesByIdQuery,
  GetCareerRolesByIdQueryVariables,
} from 'bundles/premium-hub/queries/__generated__/getCareerRolesById';
import GetCareerRolesById from 'bundles/premium-hub/queries/getCareerRolesById.graphql';

export const useCareerRolesByIds = (
  careerRoleIds: string[],
  skip: boolean = true,
  enableRoleTaxonomy2: boolean = false
) => {
  const { data, loading } = useQuery<GetCareerRolesByIdQuery, GetCareerRolesByIdQueryVariables>(GetCareerRolesById, {
    context: { clientName: 'gatewayGql' },
    variables: {
      ids: careerRoleIds,
      enableRoleTaxonomy2,
    },
    skip,
    errorPolicy: 'all',
    onError: (error) =>
      Sentry.captureException(error, {
        extra: {
          message: 'Error fetching premium hub career roles by IDs',
        },
      }),
  });

  return { data, loading };
};
